<template>
  <!-- <div> -->
  <!-- <ion-button
            fill="clear"
            expand="block"
            @click="showDebugging = !showDebugging"
            >{{
                showDebugging ? "Debugging ausblenden" : "Debugging anzeigen"
            }}</ion-button
        > -->
  <!-- <div v-if="showDebugging">
    Anlass: {{ selectedCondition.name }}<br />
    Konfiguration: {{ configName }}<br />
    Anzahl Fragen: {{ questions.length }}<br />
    Aktuelle Frage: {{ questionIndex }} ({{
      questions[questionIndex] ? questions[questionIndex].id : "leer"
    }})<br />
    Anzahl Antworten: {{ answers.length }}
  </div> -->
  <!-- <template v-if="showPrivacy">
    <PrivacyZTK
      v-if="routing === 'ZTK'"
      @done="
        showPrivacy = false;
        showAnswers = true;
      "
    />
    <PrivacyBetterDoc
      v-else-if="routing === 'BetterDoc'"
      @done="
        showPrivacy = false;
        showAnswers = true;
      "
    />
    <PrivacyArag
      v-else-if="routing.startsWith('ARAG Case Management')"
      @done="
        showPrivacy = false;
        showAnswers = true;
      "
    />
    <privacy
      v-else
      @done="
        showPrivacy = false;
        showAnswers = true;
      "
      :routing="routing"
    />
  </template> -->
  <transition name="fade">
    <answer-summary
      v-show="showAnswers"
      ref="answerSummaryElement"
      :files="files"
      :userFiles="userFiles"
      :partnerFiles="partnerFiles"
      :questions="questions"
      :questionsObject="questionsObject"
      :answers="answers"
      :selectedCondition="selectedCondition"
      :selectedSentence="selectedSentence"
      :routing="routing"
      :zahn="zahn"
      :mental="mental"
      :shouldOpenInteliwiseModal="shouldOpenInteliwiseModal"
      @edit-question="editQuestion($event)"
      @back-to-search="backToSearch($event)" />
  </transition>

  <template v-if="!showAnswers">
    <questions-list
      ref="questionsList"
      :questions="questions"
      :genderValue="genderValue"
      :selectedCondition="selectedCondition"
      :questionIndex="questionIndex"
      :person="person"
      :selectedArea="selectedArea"
      :roodieExpression="roodieExpression"
      :zahn="zahn"
      :herzDiabetes="herzDiabetes"
      :routing="routing"
      :files="files"
      :userFiles="userFiles"
      :partnerfiles="partnerFiles"
      :questionsObject="questionsObject"
      :answers="answers"
      :answersObject="answersObject"
      :selectedSentence="selectedSentence"
      :mental="mental"
      :shouldOpenInteliwiseModal="shouldOpenInteliwiseModal"
      :shouldStepBack="shouldStepBack"
      @next-question="nextQuestion"
      @edit-question="editQuestion($event)"
      @back-to-search="backToSearch($event)" />
  </template>

  <ion-modal
    :is-open="$store.state.showOrthodonticsModal"
    :css-class="['c-autoheight-modal']"
    @didDismiss="$store.commit('setShowOrthodonticsModal', false)">
    <ion-page>
      <div class="ion-padding modal-content ion-text-center">
        <modal-close />
        <roodie fillOuter="#5E58BE" :expression="'happy'" />
        <!-- <ion-grid>
          <ion-row>
            <ion-col size="auto">
              <ion-icon :icon="hammer" size="large"></ion-icon>
            </ion-col>
            <ion-col>
              Am Thema Kieferorthopädie arbeiten wir noch. Gerne informieren wir
              Sie, sobald wir Ihnen auch dazu helfen können.
            </ion-col>
          </ion-row>
        </ion-grid> -->
        <h6>
          An diesem Thema arbeiten wir noch. Möchten Sie, dass wir Sie
          informieren, sobald wir Ihnen auch dazu helfen können?
        </h6>
        <div class="ion-margin-top">
          <ion-button
            @click="
              modalController.dismiss();
              if (shouldOpenEndModal) openEndModal();
            "
            >Nein</ion-button
          >
          <ion-button
            @click="
              modalController.dismiss();
              if (shouldOpenEndModal) openEndModal();
            "
            >Ja</ion-button
          >
        </div>
      </div>
    </ion-page>
  </ion-modal>

  <ion-modal
    :is-open="showDentNetModal"
    :css-class="['c-autoheight-modal']"
    @didDismiss="showDentNetModal = false">
    <ion-page>
      <div class="ion-padding modal-content ion-text-center">
        <modal-close />
        <roodie fillOuter="#5E58BE" :expression="'happy'" />
        <p>
          Wir arbeiten an der Erweiterung unseres Services. Nord-Deutschland
          decken wir aktuell noch nicht ab, Sie können aber gerne das Service
          der <b>Zahnärztlichen Tageskliniken</b> nutzen, um einen Zahnarzt im
          Süden Deutschlands aufzusuchen.
        </p>
        <p>
          Als Alternative bieten wir Ihnen auch eine Suche eines Zahnarztes in
          Ihrer Nähe über
          <a href="https://www.arag.de/service/zahnarztsuche/" target="_blank"
            >DentNet</a
          >
          an.
        </p>
      </div>
    </ion-page>
  </ion-modal>

  <ion-modal
    :is-open="isContactModalOpen"
    css-class="my-custom-class"
    @didDismiss="isContactModalOpen = false">
    <ion-page>
      <ion-header class="ion-no-border">
        <ion-toolbar>
          <ion-title>Terminauswahl</ion-title>
          <ion-buttons slot="end">
            <ion-button @click="modalController.dismiss()"
              >Schließen</ion-button
            >
          </ion-buttons>
        </ion-toolbar>
      </ion-header>
      <ion-content ref="content" class="ion-padding">
        (Datum/Uhrzeit) für RR-Buchung
      </ion-content>
    </ion-page>
  </ion-modal>

  <ion-action-sheet
    :is-open="isCallSheetOpen"
    header="Call Medgate"
    css-class="my-custom-class"
    :buttons="callSheetButtons"
    @didDismiss="isCallSheetOpen = false">
  </ion-action-sheet>
  <!-- </div> -->
</template>

<script>
import { ref, computed, watch, toRefs } from "vue";
// import be from "@/utils/questions/beschwerdenEinstieg";
// import af from "@/utils/questions/aragFragen";
import be from "@/utils/questions/beschwerden";
import zm from "@/utils/questions/zweitmeinung";
import fa from "@/utils/questions/facharzt";
import zb from "@/utils/questions/zahnBeschwerden";
import zf from "@/utils/questions/zahnFacharzt";
import zt from "@/utils/questions/zahnTermin";
import zk from "@/utils/questions/zahnKosmetisch";
import AnswerSummary from "@lib/components/AnswerSummary";
// import Privacy from "@/components/Privacy";
// import PrivacyZTK from "@/components/PrivacyZTK";
// import PrivacyBetterDoc from "@/components/PrivacyBetterDoc";
// import PrivacyArag from "@/components/PrivacyArag";
import {
  IonButton,
  IonModal,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonButtons,
  modalController,
  IonPage,
  IonActionSheet,
  // IonGrid,
  // IonRow,
  // IonCol,
  // IonIcon,
} from "@ionic/vue";
import QuestionsList from "@lib/components/QuestionsList";
import { callOutline, hammer } from "ionicons/icons";
import { useGtm } from "vue-gtm";
// import FormCoaching from "@/components/FormCoaching";
import EndModal from "@/components/EndModal";
import Roodie from "@lib/components/svg/Roodie";
import { useStore } from "vuex";
import ModalClose from "@lib/components/ModalClose";
import InteliwiseModal from "@/components/InteliwiseModal";
import PartnerModal from "@/components/PartnerModal";
import { saveCheck } from "@/api/roodiecheck";
import { useDoctor } from "@/composables/useDoctor";

export default {
  emits: ["stepped-back", "back-to-search", "progress-change", "show-paintype"],
  components: {
    AnswerSummary,
    // Privacy,
    // PrivacyZTK,
    // PrivacyBetterDoc,
    // PrivacyArag,
    IonButton,
    QuestionsList,
    IonModal,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonButtons,
    IonPage,
    IonActionSheet,
    // IonGrid,
    // IonRow,
    // IonCol,
    // IonIcon,
    Roodie,
    ModalClose,
  },
  props: {
    selectedCondition: {
      required: true,
      type: Object,
    },
    selectedSentence: {
      required: true,
      type: String,
    },
    person: {
      required: true,
      type: String,
    },
    genderValue: {
      required: true,
      type: String,
    },
    shouldStepBack: {
      required: true,
      type: Boolean,
    },
    shouldOpenInteliwiseModal: {
      required: true,
      type: Boolean,
    },
    scrollElement: {
      required: false,
      default: null,
    },
  },
  watch: {
    shouldStepBack(val) {
      if (val) {
        if (
          this.questions[this.questionIndex].type === "painarea" &&
          this.$store.state.painareaSelectedMapHistory.length
        ) {
          //   this.$refs.questionsList.stepBack();
        }
        // if (this.showPrivacy) {
        //   this.showPrivacy = false;
        // } else
        else if (this.showAnswers) {
          this.showAnswers = false;
        } else if (this.questionIndex > 0) {
          this.questionIndex--;
        } else {
          // if (this.selectedCondition.type) {
          //   this.$emit("show-paintype", true);
          // }
          this.backToSearch();
        }
        this.$emit("stepped-back");
      }
    },
  },
  data() {
    return {
      showDebugging: false,
    };
  },
  setup(props, { emit }) {
    const store = useStore();
    const gtm = useGtm();
    const showOrthodonticsModal = ref(false);
    const shouldOpenEndModal = ref(false);
    const showDentNetModal = ref(false);
    const isContactModalOpen = ref(false);
    const isCallSheetOpen = ref(false);
    const callSheetButtons = [
      { text: "+43 123456789", icon: callOutline },
      { text: "Schließen", role: "cancel" },
    ];
    const configName = ref("");

    const answers = ref([]);
    const answersObject = computed(() => {
      const result = {};
      for (const answer of answers.value) {
        if (answer.valueId) {
          result[answer.id] = answer.valueId;
          result[answer.id + "_value"] = answer.value;
        } else if (answer.valueIds) {
          // result[answer.id] = answer.valueIds;
          result[answer.id] = answer.value;
          result[answer.id + "_values"] = answer.valueIds;
        } else {
          result[answer.id] = answer.value;
        }
        if (answer.area) {
          result[answer.id + "_area"] = answer.area;
        }
        if (answer.category) {
          result[answer.id + "_category"] = answer.category;
        }
      }
      return result;
    });
    const bodySelectAnswer = computed(() => {
      const answer = answers.value.find((obj) => {
        return obj.id === "be-2";
      });
      if (answer) {
        return answer;
      } else {
        return {};
      }
    });
    // const genderValue = computed(() => {
    //     let result = "man";
    //     if (answersObject.value["be-6"]) {
    //         result = answersObject.value["be-6"];
    //     }
    //     return result;
    // });
    const config = ref([]);
    const includesSome = (src, search) => {
      let result = false;
      if (src) {
        for (const searchElement of search) {
          if (src.includes(searchElement)) {
            result = true;
            break;
          }
        }
      }
      console.log("includesSome", result);
      return result;
    };
    const zahn = ref(props.selectedCondition.name?.startsWith("tooth"));
    const kiefer = ref(false);
    const herzDiabetes = ref(false);
    const mental = ref(false);
    const routing = ref("BetterDoc");
    const questions = computed(() => {
      const result = [];
      let skipTo = "";

      for (const entry of config.value) {
        let question = {};
        const questionId = entry.id;
        const questionKey = questionId.substring(3);
        // const questionVersion = entry.version;
        if (questionId.startsWith("be-")) {
          question = be[questionKey];
        } else if (questionId.startsWith("zm-")) {
          question = zm[questionKey];
        } else if (questionId.startsWith("fa-")) {
          question = fa[questionKey];
        } else if (questionId.startsWith("zb-")) {
          question = zb[questionKey];
        } else if (questionId.startsWith("zf-")) {
          question = zf[questionKey];
        } else if (questionId.startsWith("zt-")) {
          question = zt[questionKey];
        } else if (questionId.startsWith("zk-")) {
          question = zk[questionKey];
        } else if (questionId.startsWith("iw-")) {
          question = entry.question;
        }

        if (!question) {
          question = {};
        }

        let skip = false;

        // Fragenlogik

        // Logik für Beschwerden Einstieg
        if (
          configName.value !== "zweitmeinung" &&
          ["be-16"].includes(questionId) &&
          zahn.value
        ) {
          skip = true;
        } else if (
          configName.value !== "zweitmeinung" &&
          ["be-16.1", "be-26"].includes(questionId) &&
          !zahn.value
        ) {
          skip = true;
        } else if (
          ["be-7", "be-8.1", "be-8.2"].includes(questionId) &&
          zahn.value
        ) {
          skip = true;
        } else if (["be-7.1", "be-8"].includes(questionId) && !zahn.value) {
          skip = true;
        } else if (
          questionId === "be-17" &&
          answersObject.value["be-16.1"] === "Nein"
        ) {
          skip = true;
        } else if (
          questionId === "be-8.3" &&
          !(
            [
              answersObject.value["be-4"],
              answersObject.value["be-4.1"],
            ].includes("mental") ||
            [
              answersObject.value["be-4"],
              answersObject.value["be-4.1"],
            ].includes("beides")
          )
        ) {
          skip = true;
        } else if (questionId === "be-12" && (zahn.value || mental.value)) {
          skip = true;
        } else if (questionId === "be-12.2" && !(zahn.value || mental.value)) {
          skip = true;
        } else if (
          ["zf-16", "zf-17", "be-20"].includes(questionId) &&
          !zahn.value
        ) {
          skip = true;
        }
        // else if (questionId === "be-23" && routing.value === "BetterDoc") {
        //   skip = true;
        // }
        // else if (
        //   questionId === "be-96"
        //   && routing.value !== "Medgate"
        // ) {
        //   skip = true;
        // }
        else if (
          ["zt-1", "zt-2", "zt-4"].includes(questionId) &&
          routing.value !== "ZTK"
        ) {
          skip = true;
        } else if (
          ["be-24", "be-25"].includes(questionId) &&
          (answersObject.value["zt-1"] === "Termin buchen" ||
            routing.value === "Medgate")
        ) {
          skip = true;
        } else if (
          questionId === "be-25" &&
          answersObject.value["be-24"] === "Nein"
        ) {
          skip = true;
        } else if (
          ["be-25.1", "be-98"].includes(questionId) &&
          answersObject.value["zt-1"] !== "Termin buchen"
        ) {
          skip = true;
        } else if (
          ["be-97"].includes(questionId) &&
          answersObject.value["zt-1"] !== "Termin anfragen"
        ) {
          skip = true;
        } else if (questionId === "be-18" && !herzDiabetes.value) {
          skip = true;
        } else if (
          (questionId === "be-19" || questionId === "be-19.2") &&
          !(
            zahn.value
            // &&
            // ![
            //   answersObject.value["be-16"],
            //   answersObject.value["be-16.1"],
            // ].includes("Nein")
          )
        ) {
          skip = true;
        } else if (
          configName.value !== "zahnBehandlungsplan" &&
          questionId === "be-19.1" &&
          answersObject.value["be-19"] !== "Ja" &&
          answersObject.value["be-19.2"] !== "Ja"
        ) {
          skip = true;
        } else if (
          ["be-20", "be-20.1"].includes(questionId) &&
          [answersObject.value["be-4"], answersObject.value["be-4.1"]].includes(
            "mental"
          )
        ) {
          skip = true;
        } else if (
          questionId === "be-20" &&
          (answersObject.value["be-19"] === "Ja" ||
            kiefer.value ||
            includesSome(answersObject.value["be-9_values"], [
              "Druckstellen",
              "Zahnersatz",
              "Zahnfehlstellung",
            ]))
        ) {
          skip = true;
        } else if (
          ["be-27", "be-27.1", "be-28"].includes(questionId) &&
          (answersObject.value["zm-5"] === "Ja" ||
            !["Nein", undefined].includes(answersObject.value["be-16"]) ||
            answersObject.value["be-16.1"] === "Ja" ||
            !["Nein", undefined].includes(answersObject.value["be-16.2"]))
        ) {
          skip = true;
        } else if (
          questionId === "be-28" &&
          answersObject.value["be-27"] !== "Ja"
        ) {
          skip = true;
        }
        // else if (
        //   configName.value !== "zahnBehandlungsplan" &&
        //   questionId === "be-27.1" &&
        //   answersObject.value["be-27"] !== "Ja"
        // ) {
        //   skip = true;
        // }
        // if (
        //   questionId === "be-10" &&
        //   answersObject.value["be-9"] &&
        //   answersObject.value["be-9"] !== "Ja"
        // ) {
        //   skip = true;
        // } else if (
        //   questionId === "be-16" &&
        //   answersObject.value["be-7"] &&
        //   !answersObject.value["be-7"].includes("torso-front")
        // ) {
        //   skip = true;
        // }
        // Ende Logik für Beschwerden Einstieg

        // Logik für configs
        if (configName.value === "beschwerden") {
          if (
            questionId === "be-4" &&
            !answersObject.value["be-2"]?.includes("head-upper-front")
          ) {
            skip = true;
          } else if (
            [
              "be-5",
              "be-7",
              "be-7.1",
              "be-8",
              "be-8.1",
              "be-8.2",
              // "be-11",
              // "be-12",
              "be-13",
              "be-14",
            ].includes(questionId) &&
            answersObject.value["be-4"] === "mental"
          ) {
            skip = true;
          } else if (
            questionId === "be-14.1" &&
            answersObject.value["be-4"] !== "mental"
          ) {
            skip = true;
          } else if (
            questionId === "be-6" &&
            answersObject.value["be-5"] !== "Ja"
          ) {
            skip = true;
          } else if (questionId === "be-7" && zahn.value) {
            skip = true;
          } else if (["be-7.1", "be-9"].includes(questionId) && !zahn.value) {
            skip = true;
          } else if (
            questionId === "be-15" &&
            answersObject.value["be-14"] !== "Vorerkrankung" &&
            answersObject.value["be-14.1"] !== "Ja"
          ) {
            skip = true;
          } else if (
            questionId === "be-17" &&
            answersObject.value["be-16"] === "Nein"
          ) {
            skip = true;
          }
        } else if (configName.value === "zweitmeinung") {
          if (skipTo === "") {
            if (
              questionId === "be-4.1" &&
              answersObject.value["zm-5"] === "Nein"
            ) {
              skipTo = "be-16.2";
            } else if (
              questionId === "be-5" &&
              (answersObject.value["be-4.1"] === "mental" ||
                answersObject.value["be-4"] === "mental")
            ) {
              skipTo = "be-8.3";
            }
          }
          if (
            ["be-16", "be-17"].includes(questionId) &&
            answersObject.value["be-15.1"] === "Nein"
          ) {
            skip = true;
          } else if (
            ["be-16.2", "be-17.1"].includes(questionId) &&
            answersObject.value["be-15.1"] !== "Nein"
          ) {
            skip = true;
          } else if (
            ["be-16"].includes(questionId) &&
            ["X", "kiefer"].includes(answersObject.value["be-15.1"])
          ) {
            skip = true;
          } else if (
            ["be-16.1", "be-26"].includes(questionId) &&
            !["X", "kiefer"].includes(answersObject.value["be-15.1"])
          ) {
            skip = true;
          } else if (
            questionId === "be-17" &&
            answersObject.value["be-16"] === "Nein"
          ) {
            skip = true;
          } else if (
            questionId === "be-17.1" &&
            answersObject.value["be-16.2"] === "Nein"
          ) {
            skip = true;
          } else if (
            questionId === "be-2" &&
            answersObject.value["zm-5"] !== "Ja"
          ) {
            skip = true;
          } else if (
            questionId === "be-4.1" &&
            answersObject.value["be-15.1"] !== "mental"
          ) {
            skip = true;
          } else if (
            questionId === "be-2" &&
            answersObject.value["be-4.1"] === "mental"
          ) {
            skip = true;
          } else if (
            questionId === "be-4" &&
            (answersObject.value["be-4.1"] ||
              !answersObject.value["be-2"]?.includes("head-upper-front"))
          ) {
            skip = true;
          } else if (
            [
              "be-5",
              "be-7",
              "be-8",
              "be-8.1",
              "be-8.2",
              // "be-11",
              // "be-12",
              "be-13",
            ].includes(questionId) &&
            [
              answersObject.value["be-4"],
              answersObject.value["be-4.1"],
            ].includes("mental")
          ) {
            skip = true;
          } else if (
            questionId === "be-6" &&
            answersObject.value["be-5"] !== "Ja"
          ) {
            skip = true;
          } else if (questionId === "be-9" && !zahn.value) {
            skip = true;
          } else if (
            questionId === "be-19" &&
            ["Zahnersatz"].includes(answersObject.value["be-15.1_category"]) &&
            answersObject.value["be-16.1"] === "Nein"
          ) {
            skip = true;
          } else if (
            ["be-27", "be-27.1", "be-28"].includes(questionId) &&
            !["Zahnersatz"].includes(answersObject.value["be-15.1_category"])
          ) {
            skip = true;
          }
        } else if (["facharzt", "facharztCard"].includes(configName.value)) {
          if (skipTo === "") {
            if (
              questionId === "be-4.1" &&
              answersObject.value["zm-5"] === "Nein"
            ) {
              // if (configName.value === "facharzt") {
              skipTo = "be-16";
              // } else {
              //   skipTo = "zf-17";
              // }
            } else if (
              questionId === "be-5" &&
              (answersObject.value["be-4.1"] === "mental" ||
                answersObject.value["be-4"] === "mental")
            ) {
              skipTo = "be-8.3";
            }
          }
          if (
            questionId === "be-15" &&
            answersObject.value["be-14"] !== "Vorerkrankung"
          ) {
            skip = true;
          } else if (
            questionId === "be-4.1" &&
            answersObject.value["fa-2"] !== "mental" &&
            answersObject.value["be-15"] !== "mental"
          ) {
            skip = true;
          } else if (
            questionId === "be-2" &&
            answersObject.value["be-4.1"] === "mental"
          ) {
            skip = true;
          } else if (
            questionId === "be-4" &&
            (answersObject.value["be-4.1"] ||
              !answersObject.value["be-2"]?.includes("head-upper-front"))
          ) {
            skip = true;
          } else if (
            [
              "be-5",
              "be-7",
              "be-8",
              "be-8.1",
              "be-8.2",
              // "be-11",
              // "be-12",
              "be-13",
              // "be-16",
            ].includes(questionId) &&
            [
              answersObject.value["be-4"],
              answersObject.value["be-4.1"],
            ].includes("mental")
          ) {
            skip = true;
          } else if (
            questionId === "be-6" &&
            answersObject.value["be-5"] !== "Ja"
          ) {
            skip = true;
          } else if (
            ["be-9", "fa-20", "fa-21", "be-19"].includes(questionId) &&
            !zahn.value
          ) {
            skip = true;
          } else if (
            questionId === "be-17" &&
            ["Nein", undefined].includes(answersObject.value["be-16"])
          ) {
            skip = true;
          } else if (
            questionId === "be-19" &&
            ((["Zahnlabor"].includes(answersObject.value["fa-2_value"]) &&
              answersObject.value["zm-5"] === "Nein") ||
              (!store.getters.isNorthGermany &&
                answersObject.value["be-14"] === "Nein" &&
                answersObject.value["zm-5"] === "Nein"))
          ) {
            skip = true;
          } else if (
            ["be-27", "be-27.1", "be-28"].includes(questionId) &&
            !["Zahnlabor"].includes(answersObject.value["fa-2_value"])
          ) {
            skip = true;
          } else if (
            // QS AUSBAU START
            questionId === "be-20" &&
            !(
              zahn.value &&
              !kiefer.value &&
              !store.getters.isNorthGermany &&
              answersObject.value["be-14"] === "Nein" &&
              answersObject.value["zm-5"] === "Nein"
            )
            // QS AUSBAU END
          ) {
            skip = true;
          } else if (
            questionId === "be-19.2" &&
            (answersObject.value["be-19"] ||
              kiefer.value ||
              (answersObject.value["zm-5"] !== "Nein" &&
                !routing.value.startsWith("ARAG Case Management")))
          ) {
            skip = true;
          }
        } else if (
          ["zahnBeschwerden", "zahnKiefer"].includes(configName.value)
        ) {
          if (skipTo === "") {
            // if (
            //   questionId === "zm-5" &&
            //   includesSome(answersObject.value["zb-1"], [
            //     "Professionelle Zahnreinigung",
            //     "Kosmetische Behandlung",
            //     "Kontrolltermin",
            //   ]) &&
            //   !answersObject.value["zb-1"]?.includes(
            //     "Schmerzen/Beschwerden"
            //   )
            // ) {
            //   skipTo = "zf-17";
            // } else
            if (
              questionId === "be-2" &&
              answersObject.value["zm-5"] === "Nein"
            ) {
              skipTo = "be-27";
            }
          }
          if (
            questionId === "zm-5" &&
            props.selectedCondition.value === "Schmerzen/Beschwerden"
          ) {
            skip = true;
          } else if (
            questionId === "be-6" &&
            answersObject.value["be-5"] !== "Ja"
          ) {
            skip = true;
          } else if (
            questionId === "be-15" &&
            answersObject.value["be-14"] !== "Vorerkrankung"
          ) {
            skip = true;
          } else if (
            questionId === "be-17" &&
            answersObject.value["be-16"] === "Nein"
          ) {
            skip = true;
          }
        } else if (configName.value === "zahnZweitmeinung") {
          if (skipTo === "") {
            if (
              questionId === "be-2" &&
              answersObject.value["zm-5"] === "Nein"
            ) {
              skipTo = "be-19";
            }
          }
          if (
            questionId === "be-17" &&
            answersObject.value["be-16"] === "Nein"
          ) {
            skip = true;
          } else if (
            questionId === "be-2" &&
            answersObject.value["zm-5"] !== "Ja"
          ) {
            skip = true;
          } else if (
            questionId === "be-6" &&
            answersObject.value["be-5"] !== "Ja"
          ) {
            skip = true;
          }
          // else if (
          //   ["be-9"].includes(questionId) &&
          //   answersObject.value["be-15.2"] !== "Nein"
          // ) {
          //   skip = true;
          // }
          else if (
            questionId === "be-19" &&
            ["Zahnersatz"].includes(answersObject.value["be-15.2_category"]) &&
            answersObject.value["be-16.1"] === "Nein" &&
            answersObject.value["zm-5"] === "Nein"
          ) {
            skip = true;
          } else if (
            ["be-27", "be-27.1", "be-28"].includes(questionId) &&
            !["Zahnersatz"].includes(answersObject.value["be-15.2_category"])
          ) {
            skip = true;
          }
        } else if (configName.value === "zahnFacharzt") {
          if (skipTo === "") {
            if (
              questionId === "be-2" &&
              answersObject.value["zm-5"] === "Nein"
            ) {
              skipTo = "fa-20";
            }
          }
          if (questionId === "be-6" && answersObject.value["be-5"] !== "Ja") {
            skip = true;
          } else if (
            questionId === "be-17" &&
            answersObject.value["be-16"] === "Nein"
          ) {
            skip = true;
          }
        }

        // Zusätzliche Logik für bestimmte configs
        if (configName.value === "zahnKiefer") {
          if (
            ["be-17"].includes(questionId) &&
            answersObject.value["be-16.1"] === "Nein"
          ) {
            skip = true;
          } else if (
            ["be-27", "be-27.1", "be-28"].includes(questionId) &&
            props.selectedCondition.value === "Brauche einen Kieferorthopäden"
          ) {
            skip = true;
          } else if (questionId === "be-19" && answersObject.value["be-27"]) {
            skip = true;
          }
          // else if (
          //   questionId === "be-100" &&
          //   answersObject.value["be-16.1"] === "Nein" &&
          //   answersObject.value["zm-5"] === "Nein"
          // ) {
          //   skip = true;
          // }
        } else if (configName.value === "facharzt") {
          if (skipTo === "") {
            // if (questionId === "be-16.1" && routing.value === "ZTK") {
            //   skipTo = "be-23";
            // } else
            if (
              questionId === "be-16.1" &&
              zahn.value &&
              answersObject.value["be-14"] === "Nein" &&
              answersObject.value["zm-5"] === "Nein"
            ) {
              skipTo = "be-19";
            } else if (questionId === "be-24" && routing.value === "ZTK") {
              skipTo = "end";
            }
          }
          // QS AUSBAU START
          // if (
          //   questionId === "be-19" &&
          //   !store.getters.isNorthGermany &&
          //   !kiefer.value &&
          //   answersObject.value["zm-5"] !== "Ja"
          // ) {
          //   skip = true;
          // } else if (
          //   questionId === "be-19.2" &&
          //   (answersObject.value["be-19"] ||
          //     !routing.value.startsWith("ARAG Case Management"))
          // ) {
          //   skip = true;
          // }
          // QS AUSBAU END
        }
        // Ende Logik für configs

        // Generelle skipTo Logik wurde ab dem neuen Excel ARAG_Bot_V6_Per_Sie_2021-03-15 eingebaut
        if (skipTo !== "" && questionId !== skipTo) {
          skip = true;
        } else {
          skipTo = "";
        }

        if (!skip) {
          question.id = questionId;
          result.push(question);
        }
      }
      return result;
    });

    const getQuestionText = (question) => {
      let result = "";
      if (question?.summary?.text) {
        result = question.summary.text;
      } else if (typeof question.text === "object") {
        if (question.text.zahn && zahn.value) {
          result = question.text.zahn;
        } else if (question.text.all) {
          result = question.text.all;
        }
      } else {
        result = question.text;
      }
      return result;
    };

    const { scrollElement } = toRefs(props);
    const questionIndex = ref(0);
    const roodieExpression = ref("happy");
    watch(questionIndex, (newValue) => {
      scrollElement.value.scrollTop = 0;
      const expressions = ["happy", "meh"];
      const randomExpression =
        expressions[Math.floor(Math.random() * expressions.length)];
      roodieExpression.value = randomExpression;
      if (questions.value.length > 0) {
        emit("progress-change", newValue / questions.value.length);
        gtm.trackView(
          getQuestionText(questions.value[newValue]),
          "/chat/" +
            props.selectedCondition.name +
            "/" +
            questions.value[newValue].id
        );
      }
    });
    // const showPrivacy = ref(false);
    const showAnswers = ref(false);
    watch(showAnswers, (newValue) => {
      if (newValue) {
        // if (answersObject.value["be-18"] === "Ja") {
        //   modalController
        //     .create({
        //       component: FormCoaching,
        //     })
        //     .then((modal) => {
        //       modal.present();
        //     });
        // }
        emit("progress-change", 1);
        gtm.trackView(
          "Chat Zusammenfassung",
          "/chat/" + props.selectedCondition.name + "/summary"
        );
      } else {
        emit("progress-change", questionIndex.value / questions.value.length);
      }
    });

    const questionsObject = computed(() => {
      const result = {};
      for (const question of questions.value) {
        result[question.id] = question;
      }
      return result;
    });

    const openInteliwiseModal = async () => {
      const inteliwiseAnswers = [
        {
          "Sagen Sie uns, was Ihnen fehlt oder was Sie brauchen:":
            props.selectedSentence,
        },
      ];
      for (const answer of answers.value) {
        inteliwiseAnswers.push({ [answer.question.text]: answer.value });
      }
      const modal = await modalController.create({
        componentProps: {
          inteliwiseAnswers: inteliwiseAnswers,
        },
        component: InteliwiseModal,
      });
      modal.onDidDismiss().then(() => {
        const inteliwiseHistory =
          window.inteliwiseAPI?.widgets?.default?.history?.data;
        if (inteliwiseHistory) {
          for (const [index, entry] of inteliwiseHistory.entries()) {
            if (entry.type === "ANSWER") {
              if (
                answers.value.length === 0 ||
                answers.value[answers.value.length - 1].value
              ) {
                config.value.push({
                  id: "iw-" + index,
                  question: { text: entry.text },
                });
                answers.value.push({
                  id: "iw-" + index,
                  value: "",
                  base64: "",
                });
              } else {
                config.value[config.value.length - 1].question.text +=
                  "<br>" + entry.text;
              }
            } else if (entry.type === "ACK_SEND") {
              if (entry.file?.data) {
                if (
                  answers.value[answers.value.length - 1].value ||
                  answers.value[answers.value.length - 1].base64
                ) {
                  config.value.push({
                    id: "iw-" + index,
                    question: { text: "" },
                  });
                  answers.value.push({
                    id: "iw-" + index,
                    base64: "data:image/jpeg;base64," + entry.file.data,
                  });
                } else {
                  answers.value[answers.value.length - 1].base64 =
                    "data:image/jpeg;base64," + entry.file.data;
                }
              } else {
                if (answers.value[answers.value.length - 1].base64) {
                  config.value.push({
                    id: "iw-" + index,
                    question: { text: "" },
                  });
                  answers.value.push({
                    id: "iw-" + index,
                    value: entry.text,
                  });
                } else {
                  if (answers.value[answers.value.length - 1].value) {
                    answers.value[answers.value.length - 1].value += "<br>";
                  }
                  answers.value[answers.value.length - 1].value += entry.text;
                }
              }
            }
            const answerIndex = answers.value.findIndex((obj) => {
              return obj.id === "iw-" + index;
            });
            if (answerIndex && questionsObject.value["iw-" + index]) {
              answers.value[answerIndex].question =
                questionsObject.value["iw-" + index];
            }
          }
        }
        routing.value = "BetterDoc";
        showAnswers.value = true;
      });
      return modal.present();
    };

    watch(props.selectedCondition, (newVal) => {
      if (Object.keys(newVal).length === 0) {
        config.value = [];
        configName.value = "";
        answers.value = [];
      }
    });
    const backToSearch = (force = false) => {
      emit("back-to-search", force);
    };

    const answerSummaryElement = ref(null);
    const shouldShowAnswers = ref(false);
    const editQuestion = (id) => {
      const foundQuestionIndex = questions.value.findIndex(
        (obj) => obj.id === id
      );
      if (foundQuestionIndex !== -1) {
        questionIndex.value = foundQuestionIndex;
        showAnswers.value = false;
        shouldShowAnswers.value = true;
      }
    };
    watch(questionsObject, (newValue, oldValue) => {
      if (shouldShowAnswers.value) {
        // console.log("drin");
        const oldKeys = Object.keys(oldValue);
        const newKeys = Object.keys(newValue);
        const includesAll = newKeys.every((key) => {
          return oldKeys.includes(key);
        });
        if (includesAll) {
          console.log("set showPrivacy");
          // showPrivacy.value = true;
          const answerSummaryIndex = questions.value.findIndex(
            (obj) => obj.id === "be-100"
          );
          if (answerSummaryIndex !== -1) {
            questionIndex.value = answerSummaryIndex;
          } else {
            questionIndex.value = questions.value.length - 1;
            // showAnswers.value = true;
            answerSummaryElement.value.next();
          }
        }
        shouldShowAnswers.value = false;
      }
    });

    const selectedArea = ref(props.selectedCondition.area);
    const ztkBookingLocation = computed(
      () => answersObject.value["zt-4_values"]
    );
    const syncAnswers = () => {
      for (let index = 0; index < answers.value.length; index++) {
        if (!answers.value[index].isAdditionalAnswer) {
          const foundQuestion = questions.value.find(
            (question) => question.id === answers.value[index].id
          );
          if (!foundQuestion) {
            answers.value.splice(index, 1);
            index--;
          }
        }
      }
      if (!(configName.value === "facharzt" && routing.value === "ZTK")) {
        if (
          ["beschwerden", "zweitmeinung", "facharzt", "facharztCard"].includes(
            configName.value
          )
        ) {
          // console.log(answersObject.value["be-20"]);
          if (
            mental.value &&
            ![
              answersObject.value["be-4"],
              answersObject.value["be-4.1"],
            ].includes("körperlich") &&
            ![
              answersObject.value["be-4"],
              answersObject.value["be-4.1"],
            ].includes("beides")
            // ["mental", "beides"].includes(answersObject.value["be-4"]) ||
            // answersObject.value["fa-2"] === "mental" ||
            // answersObject.value["be-15"] === "mental" ||
            // answersObject.value["be-15.1"] === "mental" ||
            // answersObject.value["be-15.2"] === "mental"
          ) {
            routing.value = "ARAG Case Management Mental";
          }
          // QS AUSBAU START
          else if (answersObject.value["be-27"] === "Ja") {
            routing.value = "Quality Smile";
          }
          // else if (
          //   (answersObject.value["be-20"] === "A" ||
          //     answersObject.value["be-20.1"] === "A") &&
          //   zahn.value
          // ) {
          //   routing.value = "Quality Smile";
          // } else if (
          //   answersObject.value["be-20"] === "B" ||
          //   answersObject.value["be-20.1"] === "B"
          // ) {
          //   routing.value = "Medgate";
          // } else if (answersObject.value["be-20"] === "C") {
          //   routing.value = "ARAG Case Management Zahn";
          // }
          // QS AUSBAU END
          else if (zahn.value) {
            // routing.value = "ZTK";
            routing.value = "ARAG Case Management Zahn";
          } else {
            routing.value = "BetterDoc";
          }
        } else if (
          ["zahnBeschwerden", "zahnFacharzt"].includes(configName.value)
        ) {
          // QS AUSBAU START
          routing.value = "ARAG Case Management Zahn";
          // if (
          //   answersObject.value["be-20"] === "A" ||
          //   answersObject.value["be-20.1"] === "A"
          // ) {
          //   routing.value = "Quality Smile";
          // } else if (answersObject.value["be-20.1"] === "B") {
          //   routing.value = "Medgate";
          // } else {
          //   // routing.value = "ZTK";
          //   routing.value = "ARAG Case Management Zahn";
          // }
          // QS AUSBAU END
        } else if (
          ["zahnZweitmeinung", "zahnKiefer", "zahnBehandlungsplan"].includes(
            configName.value
          )
        ) {
          // QS AUSBAU START
          if (answersObject.value["be-27"] === "Ja") {
            routing.value = "Quality Smile";
          } else {
            routing.value = "ARAG Case Management Zahn";
          }
          // if (answersObject.value["be-20"] === "A") {
          //   routing.value = "ZTK";
          // } else if (answersObject.value["be-20"] === "B") {
          //   routing.value = "Medgate";
          // } else if (answersObject.value["be-20"] === "C") {
          //   routing.value = "ARAG Case Management Zahn";
          // } else {
          //   // routing.value = "ZTK";
          //   routing.value = "ARAG Case Management Zahn";
          // }
          // QS AUSBAU END
        }

        if (answersObject.value["be-19"] === "Ja") {
          routing.value = "ARAG Case Management Zahn";
        }

        console.log("routing", routing.value);
      }
    };

    const openEndModal = async (routing = "") => {
      const ztkBookingText = answersObject.value["zt-1"];
      const modal = await modalController.create({
        component: EndModal,
        componentProps: {
          routing: routing,
          ztkBookingText: ztkBookingText,
          ztkBookingLocation: ztkBookingLocation.value,
        },
      });
      modal.onDidDismiss().then((result) => {
        // window.location.reload();
        // if (result.data?.newRouting !== "afterZTK") {
        if (result.data?.newRouting) {
          openEndModal(result.data.newRouting);
        } else {
          store.commit("setResetHomeViewForce", true);
        }
        // }
      });
      return modal.present();
    };

    const files = ref([]);
    const userFiles = ref([]);
    const partnerFiles = ref([]);
    const { addDoctor } = useDoctor();
    const nextQuestion = (answer) => {
      const handleAnswer = async (answer) => {
        console.log(answer);
        if (questionIndex.value === 0) {
          gtm.trackView(
            questions.value[0].text,
            "/chat/" +
              props.selectedCondition.name +
              "/" +
              questions.value[0].id
          );
        }
        gtm.trackEvent({
          // event: null, // Event type [default = 'interaction'] (Optional)
          category: "Chat - Antworten",
          action: answer.value,
          label: getQuestionText(questions.value[questionIndex.value]),
          value: 1,
          // noninteraction: false, // Optional
        });
        const foundAnswerIndex = answers.value.findIndex(
          (obj) => obj.id === answer.id
        );
        if (questionsObject.value[answer.id]) {
          answer.question = questionsObject.value[answer.id];
        }
        if (["be-19.1", "be-27.1"].includes(answer.id)) {
          if (answer.files) {
            files.value = answer.files;
            delete answer.files;
          } else {
            files.value = [];
          }
          if (answer.userFiles) {
            userFiles.value = answer.userFiles;
            delete answer.userFiles;
          } else {
            userFiles.value = [];
          }
          if (answer.partnerFiles) {
            partnerFiles.value = answer.partnerFiles;
            delete answer.partnerFiles;
          } else {
            partnerFiles.value = [];
          }
        } else if (
          ["be-19", "be-27"].includes(answer.id) &&
          answer.value === "Nein"
        ) {
          files.value = [];
          userFiles.value = [];
          partnerFiles.value = [];
        }
        if (foundAnswerIndex !== -1) {
          answers.value[foundAnswerIndex] = answer;
        } else {
          answers.value.push(answer);
        }
        // console.log(questions.value.length);
        // console.log(questionIndex);

        selectedArea.value = props.selectedCondition.area;
        kiefer.value =
          answersObject.value["be-15"] === "kiefer" ||
          answersObject.value["be-15.1"] === "kiefer" ||
          answersObject.value["fa-2"] === "kiefer" ||
          bodySelectAnswer.value.painType === "Kieferbeschwerden";
        const previousZahnValue = zahn.value;
        zahn.value =
          props.selectedCondition.name?.startsWith("tooth") ||
          answersObject.value["be-15"] === "X" ||
          answersObject.value["be-15.1"] === "X" ||
          answersObject.value["fa-2"] === "zahn" ||
          ["man-mouth", "woman-mouth"].includes(answersObject.value["be-2"]) ||
          kiefer.value;
        herzDiabetes.value =
          answersObject.value["be-15"]?.toLowerCase().includes("herz") ||
          answersObject.value["be-15"]?.toLowerCase().includes("diabetes") ||
          answersObject.value["be-15.1"]?.toLowerCase().includes("herz") ||
          answersObject.value["be-15.1"]?.toLowerCase().includes("diabetes") ||
          answersObject.value["be-15.2"]?.toLowerCase().includes("herz") ||
          answersObject.value["be-15.2"]?.toLowerCase().includes("diabetes") ||
          answersObject.value["be-15_value"]?.toLowerCase().includes("herz") ||
          answersObject.value["be-15_value"]
            ?.toLowerCase()
            .includes("diabetes") ||
          answersObject.value["be-15.1_value"]
            ?.toLowerCase()
            .includes("herz") ||
          answersObject.value["be-15.1_value"]
            ?.toLowerCase()
            .includes("diabetes") ||
          answersObject.value["be-15.2_value"]
            ?.toLowerCase()
            .includes("herz") ||
          answersObject.value["be-15.2_value"]
            ?.toLowerCase()
            .includes("diabetes") ||
          answersObject.value["be-2"]?.includes("heart") ||
          answersObject.value["be-2.1"] === "Ja" ||
          answersObject.value["be-6"]?.includes("heart") ||
          answersObject.value["fa-2"] === "herz" ||
          answersObject.value["fa-2"]?.toLowerCase().includes("herz") ||
          answersObject.value["fa-2"] === "diabetes" ||
          answersObject.value["fa-2"]?.toLowerCase().includes("diabetes");
        mental.value =
          answersObject.value["fa-2"] === "mental" ||
          answersObject.value["be-15"] === "mental" ||
          answersObject.value["be-15.1"] === "mental" ||
          answersObject.value["be-15.2"] === "mental" ||
          [answersObject.value["be-4"], answersObject.value["be-4.1"]].includes(
            "mental"
          ) ||
          [answersObject.value["be-4"], answersObject.value["be-4.1"]].includes(
            "beides"
          );
        // if (props.selectedCondition.name === "doctorsearch") {
        //   zahn.value = false;
        // }
        if (
          configName.value !== "zweitmeinung" &&
          answersObject.value["be-2"] &&
          !["man-mouth", "woman-mouth"].includes(answersObject.value["be-2"]) &&
          bodySelectAnswer.value.painType !== "Kieferbeschwerden"
        ) {
          zahn.value = false;
        }

        if (configName.value === "zweitmeinung") {
          if (
            // answersObject.value["be-15"] === "X" ||
            // answersObject.value["be-15.1"] === "X"
            zahn.value
          ) {
            selectedArea.value = "head-front";
          } else if (answersObject.value["be-15_area"]) {
            selectedArea.value = answersObject.value["be-15_area"];
          } else if (answersObject.value["be-15.1_area"]) {
            selectedArea.value = answersObject.value["be-15.1_area"];
          }
          // else if (
          //   answersObject.value["be-15"] === "mental" ||
          //   answersObject.value["be-15.1"] === "mental"
          // ) {
          //   selectedArea.value = "head-front";
          // }
        } else if (["facharzt", "facharztCard"].includes(configName.value)) {
          if (
            // ["zahn", "kiefer"].includes(answersObject.value["fa-2"])
            zahn.value
          ) {
            selectedArea.value = "head-front";
          }
        }

        if (questions.value.length > questionIndex.value + 1) {
          // if (configName.value === "zweitmeinungConfig") {
          //   if (answer.id === "af-13" && answersObject.value["af-16"] === "D") {
          //     selectedArea.value = "mouth";
          //   }
          // }

          // if (
          //   answer.id === "af-2" &&
          //   answer.value ===
          //     "Ja, ich möchte jetzt gleich mit einem/r Arzt/Ärztin sprechen"
          // ) {
          //   // if (
          //   //     answer.value ===
          //   //     "Ja, ich möchte jetzt gleich mit einem/r Arzt/Ärztin sprechen"
          //   // ) {
          //   isCallSheetOpen.value = true;
          //   // }
          //   // else if (
          //   //     answer.value ===
          //   //     "Ich möchte einen Rückruf für einen bestimmten Termin buchen"
          //   // ) {
          //   //     isContactModalOpen.value = true;
          //   // }
          // } else if (answer.id === "af-2.1" && answer.value === "Ja") {
          //   isCallSheetOpen.value = true;
          // } else
          console.log("1");
          let showNextQuestion = true;
          if (
            (answer.id.startsWith("be-4") && answer.value === "mental") ||
            answer.id.startsWith("be-20") ||
            answer.id === "be-19" ||
            shouldShowAnswers.value ||
            previousZahnValue !== zahn.value ||
            answer.id === "be-100" ||
            answer.id === "be-27"
          ) {
            syncAnswers();
          }
          if (
            configName.value === "facharzt" &&
            // QS AUSBAU START (Check im Flow)
            // zahn.value &&
            // !kiefer.value &&
            // !store.getters.isNorthGermany &&
            // answersObject.value["be-14"] === "Nein" &&
            // answersObject.value["zm-5"] === "Nein" &&
            // QS AUSBAU END
            answer.id === "be-20" &&
            answer.valueId === "A"
          ) {
            routing.value = "";
            const modal = await modalController.create({
              component: PartnerModal,
              cssClass: "c-autoheight-modal",
              componentProps: {
                headline: "Erstklassige Zahnärzte in Süd-Deutschland",
                bookAppointment: () => {
                  routing.value = "ZTK";
                  modal.dismiss();
                  questionIndex.value++;
                },
                next: () => {
                  modal.dismiss();
                  openEndModal("ZTK");
                },
              },
            });
            modal.present();
            showNextQuestion = false;
          } else if (answer.isAdditionalAnswer) {
            showNextQuestion = false;
          }
          // else if (answer.id === "zb-1") {
          //   // if (answer.value.includes("Brauche einen Kieferorthopäden")) {
          //   //   showOrthodonticsModal.value = true;
          //   //   if (answer.value === "Brauche einen Kieferorthopäden") {
          //   //     showNextQuestion = false;
          //   //   }
          //   // }
          //   if (answer.value.includes("Zweite Meinung einholen")) {
          //     configName.value = "zahnZweitmeinung";
          //     import("@/utils/configs/" + configName.value + ".js").then(
          //       (array) => {
          //         config.value = array.default;
          //       }
          //     );
          //     showNextQuestion = false;
          //   }
          // }
          // else if (
          //   (answer.id === "fa-2" && answer.valueId === "kiefer") ||
          //   (answer.id.startsWith("be-15") && answer.valueId === "kiefer")
          //   // || (answer.id === "be-9" && answer.value === "Zahnfehlstellung")
          // ) {
          //   store.commit("setShowOrthodonticsModal", true);
          //   shouldOpenEndModal.value = true;
          //   showNextQuestion = false;
          // }

          // if (questionIndex.value === 0 && props.shouldOpenInteliwiseModal) {
          //   const response = await fetch(
          //     "https://inteliwise-eu.s3.amazonaws.com/_statuses_/prod/0b56d209329264b0d7c0141b052209010099e47e4dd912cb4110824c33ac6316.json"
          //   );
          //   const responseJson = await response.json();
          //   if (responseJson[-1]) {
          //     openInteliwiseModal();
          //     return;
          //   }
          // }

          if (showNextQuestion) {
            questionIndex.value++;
          }
        } else {
          console.log("2");
          syncAnswers();
          // showPrivacy.value = true;
          if (
            // props.selectedCondition.name === "toothAppointment" ||
            ["Medgate", "ZTK"].includes(routing.value)
          ) {
            store.commit("setShowLoading", true);
            const checkName =
              props.selectedSentence === "Vorsorgetermin"
                ? "Zahn - Vorsorgetermin"
                : props.selectedSentence;
            saveCheck(
              answers.value,
              checkName,
              "Weshalb suchen Sie einen Zahnarzt?"
            ).then(async (response) => {
              if (response.data.Status === "Success") {
                await addDoctor(ztkBookingLocation.value);
                openEndModal(routing.value);
              }
            });
          } else if (questionsObject.value["be-100"]) {
            answerSummaryElement.value.next();
          } else {
            // showAnswers.value = true;
            answerSummaryElement.value.next();
          }
        }
      };

      if (Array.isArray(answer)) {
        for (const singleAnswer of answer) {
          handleAnswer(singleAnswer);
        }
      } else {
        handleAnswer(answer);
      }
    };

    if (props.selectedCondition.name === "pain") {
      configName.value = "beschwerden";
    } else if (["secondopinion"].includes(props.selectedCondition.name)) {
      configName.value = "zweitmeinung";
    } else if (
      ["doctorswitch", "doctorsearch"].includes(props.selectedCondition.name)
    ) {
      configName.value = "facharzt";
    }
    // else if (props.selectedCondition.name === "doctorsearch") {
    //   configName.value = "facharztCard";
    // }
    else if (props.selectedCondition.name === "toothAppointment") {
      configName.value = "zahnTermin";
      routing.value = "ZTK";
      // answers.value.push({ id: "zt-1", value: props.selectedCondition.type });
      // questionIndex.value++;
    } else if (props.selectedCondition.name === "toothCosmetic") {
      configName.value = "zahnKosmetisch";
      routing.value = "ARAG Case Management Zahn";
    } else if (props.selectedCondition.name === "toothJaw") {
      configName.value = "zahnKiefer";
      routing.value = "ARAG Case Management Zahn";
    } else if (props.selectedCondition.name === "toothSecondopinion") {
      configName.value = "zahnZweitmeinung";
    } else if (props.selectedCondition.name === "toothTreatmentplan") {
      configName.value = "zahnBehandlungsplan";
      routing.value = "ARAG Case Management Zahn";
    } else if (props.selectedCondition.name?.startsWith("tooth")) {
      configName.value = "zahnBeschwerden";
      // routing.value = "ZTK";
      routing.value = "ARAG Case Management Zahn";
      // if (store.getters.isNorthGermany) {
      //   showDentNetModal.value = true;
      // }
    }
    // else if (props.selectedCondition.name === "toothPain") {
    //   configName.value = "zahnBeschwerden";
    // else if (props.selectedCondition.name === "toothDoctorsearch") {
    //   configName.value = "zahnFacharzt";
    // }

    if (configName.value) {
      store.commit("setShowLoading", true);
      import("@/utils/configs/" + configName.value + ".js")
        .then((array) => {
          config.value = array.default;
        })
        .finally(() => {
          store.commit("setShowLoading", false);
        });
    }

    if (
      props.selectedCondition.type === "pain" &&
      props.shouldOpenInteliwiseModal
    ) {
      openInteliwiseModal();
    }

    return {
      files,
      userFiles,
      partnerFiles,
      answerSummaryElement,
      nextQuestion,
      answers,
      config,
      questionIndex,
      questions,
      configName,
      answersObject,
      bodySelectAnswer,
      // showPrivacy,
      showAnswers,
      questionsObject,
      // genderValue,
      isContactModalOpen,
      modalController,
      isCallSheetOpen,
      callSheetButtons,
      editQuestion,
      selectedArea,
      backToSearch,
      roodieExpression,
      routing,
      zahn,
      kiefer,
      herzDiabetes,
      mental,
      showOrthodonticsModal,
      shouldOpenEndModal,
      showDentNetModal,
      hammer,
      openEndModal,
    };
  },
};
</script>

<style scoped></style>
